// extracted by mini-css-extract-plugin
module.exports = {"surveyItem":"SurveyItem_surveyItem__1TQRL","surveyItem__name":"SurveyItem_surveyItem__name___8rsy","surveyItem__link":"SurveyItem_surveyItem__link__4HeVP"};